module.exports = __webpack_public_path__ + "img/info.4fbdb215.svg";